import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

const QuoteWrapper = styled.div`
    label: QuoteWrapper;

    display: flex;
    flex-direction: column;
    ${({ align }) => {
        switch (align) {
            case "left":
                return `
                align-items: flex-start;
                > div {
                    text-align: left;
                }
            `;
            case "center":
                return `
                align-items: center;
                > div {
                    text-align: center;
                }
            `;
            case "right":
                return `
                align-items: flex-end;
                > div {
                    text-align: right;
                }
            `;
        }
    }}
`;

const QuoteStyle = styled.div`
    font-family: effra, sans-serif;
    font-size: 16pt;
    font-style: italic;
    font-weight: normal;
    padding: 10px;
`;
const AttributionStyle = styled.div`
    font-family: "effra_bold", sans-serif;
    font-size: 12pt;
`;

const QuoteAttribution = ({ align, dataQa, quote, attribution }) => (
    <QuoteWrapper align={align}>
        <QuoteStyle data-qa={`content-section-quote-body-${dataQa}`}>{quote}</QuoteStyle>
        <AttributionStyle data-qa={`content-section-quote-attribution-${dataQa}`}>—{attribution}</AttributionStyle>
    </QuoteWrapper>
);

export const QuoteAttributionPropTypes = {
    quote: PropTypes.string.isRequired,
    attribution: PropTypes.string.isRequired,
    align: PropTypes.oneOf(["left", "center", "right"]),
    dataQa: PropTypes.string
};
QuoteAttribution.propTypes = QuoteAttributionPropTypes;
QuoteAttribution.defaultProps = {
    align: "center"
};
export default QuoteAttribution;
